// utils/liveSnapshot.js
export async function captureCenterSquare(sourceEl, outSize = 800, mime = 'image/jpeg', quality = 0.92) {
  const { width, height } = getSourceSize(sourceEl);
  if (!width || !height) throw new Error('Live source not ready');

  const side = Math.min(width, height);
  const sx = Math.floor((width - side) / 2);
  const sy = Math.floor((height - side) / 2);

  const canvas = document.createElement('canvas');
  canvas.width = outSize;
  canvas.height = outSize;
  const ctx = canvas.getContext('2d');

  // 兼容 video / canvas / img
  ctx.drawImage(sourceEl, sx, sy, side, side, 0, 0, outSize, outSize);

  const blob = await new Promise((resolve, reject) => {
    canvas.toBlob((b) => (b ? resolve(b) : reject(new Error('toBlob failed'))), mime, quality);
  });

  return blob;
}

function getSourceSize(el) {
  // video
  if (el instanceof HTMLVideoElement) return { width: el.videoWidth, height: el.videoHeight };
  // canvas
  if (el instanceof HTMLCanvasElement) return { width: el.width, height: el.height };
  // img
  if (el instanceof HTMLImageElement) return { width: el.naturalWidth, height: el.naturalHeight };
  return { width: 0, height: 0 };
}

export function blobToFile(blob, filename = 'default.jpg') {
  return new File([blob], filename, { type: blob.type || 'image/jpeg' });
}
